<main class="p-3 p-lg-4 p-xxl-5">
  <div class="row g-0 border rounded-3 overflow-hidden mb-4 bg-white">
    <div class="col-12 col-lg-3 border-end">
      <div class="h-100 p-3 p-lg-4">
        <div class="text-uppercase text-muted fw-semibold small mb-2">Overall completion</div>
        <div class="display-6 fw-bold text-black lh-1 mb-3">{{ overall_completion }}%</div>
        <div class="esigning-progress-thin progress">
          <div class="signing-tracker-progress-bar progress-bar bg-dark" role="progressbar"
            :aria-valuenow="overall_completion" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
    </div>

    <div class="col-4 col-lg-3 border-end">
      <div class="h-100 p-3 p-lg-4">
        <div class="display-6 fw-bold text-success lh-1 mb-2">{{ summary_counts.signed }}</div>
        <div class="text-uppercase text-muted fw-semibold small">Signed</div>
      </div>
    </div>

    <div class="col-4 col-lg-3 border-end">
      <div class="h-100 p-3 p-lg-4">
        <div class="display-6 fw-bold text-warning lh-1 mb-2">{{ summary_counts.viewed }}</div>
        <div class="text-uppercase text-muted fw-semibold small">Viewed</div>
      </div>
    </div>

    <div class="col-4 col-lg-3">
      <div class="h-100 p-3 p-lg-4">
        <div class="display-6 fw-bold text-secondary lh-1 mb-2">{{ summary_counts.pending }}</div>
        <div class="text-uppercase text-muted fw-semibold small">Pending</div>
      </div>
    </div>
  </div>

  <section class="card border rounded-3 overflow-hidden">
    <div class="card-body p-4 p-xl-5">
      <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap pb-4 mb-4">
        <div class="min-w-0">
          <p class="text-muted mb-2">{{ tracker_document.subtitle }}</p>
          <span class="badge rounded-pill bg-success text-white border px-3 py-2">{{ tracker_document.status_label }}</span>
        </div>
        <div class="pt-4 pt-sm-0 d-flex gap-2 flex-wrap">
          <button type="button" class="btn btn-outline-secondary btn-sm fw-semibold" @click="load_tracking"
            :disabled="tracking_loading || !submission_id">
            <span v-if="tracking_loading">Refreshing...</span>
            <span v-else>Refresh</span>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm fw-semibold" @click="go_back_to_esigning">
            Back
          </button>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between gap-3 border-bottom pb-3 mb-4">
        <div class="text-uppercase text-muted fw-semibold small">Recipients - {{ recipients.length }}</div>
        <div class="small text-muted">{{ tracker_document.type }} - Sent {{ tracker_document.due_date }}</div>
      </div>

      <div v-if="tracking_error" class="border rounded-3 bg-light p-4 text-muted mb-4">
        {{ tracking_error }}
      </div>

      <div v-else-if="tracking_loading" class="border rounded-3 bg-light p-4 text-muted mb-4">
        Loading signer activity...
      </div>

      <div v-else-if="!has_recipients" class="border rounded-3 bg-light p-4 text-muted">
        Tracking data is not available for this document yet.
      </div>

      <div class="d-grid gap-4">
        <article v-for="recipient in recipients" :key="recipient.id" class="pb-4 border-bottom last:border-bottom-0">
          <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap mb-3">
            <div class="d-flex align-items-start gap-3">
              <span class="esigning-square-300 rounded-circle border d-inline-flex align-items-center justify-content-center fw-semibold text-white flex-shrink-0 text-xs">
                {{ recipient.initials }}
              </span>

              <div>
                <div class="h5 fw-bold text-black mb-1">{{ recipient.name }}</div>
                <div class="text-muted">{{ recipient.email }} - checkpoint {{ recipient.current_checkpoint }} of {{ recipient.total_checkpoints }}</div>
              </div>
            </div>

            <div class="d-flex align-items-center gap-2 flex-wrap">
              <span :class="['badge rounded-pill px-3 py-2 fw-semibold', recipient.status_badge_class]">
                {{ recipient.status_label }}
              </span>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="toggle_recipient(recipient.id)"
                :aria-expanded="is_recipient_open(recipient.id) ? 'true' : 'false'"
                :aria-label="is_recipient_open(recipient.id) ? `Collapse ${recipient.name}` : `Expand ${recipient.name}`"
              >
                <i :class="['bi small', is_recipient_open(recipient.id) ? 'bi-chevron-up' : 'bi-chevron-down']"></i>
              </button>
            </div>
          </div>

          <div v-if="is_recipient_open(recipient.id) && recipient.timeline && recipient.timeline.length" class="row g-3 align-items-center mb-3">
            <div v-for="step in recipient.timeline" :key="`${recipient.id}-${step.label}`" class="col-6 col-xl-4">
              <div class="d-flex align-items-center gap-2">
                <span
                  :class="['rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0', step.circle_class]"
                  class="esigning-square-175">
                  <i v-if="step.icon" :class="['bi', step.icon]"></i>
                  <span v-else>{{ step.number }}</span>
                </span>
                <div :class="['flex-grow-1 border-top', step.connector_class]"></div>
              </div>
              <div class="mt-2">
                <div :class="['fw-semibold', step.label_class]">{{ step.label }}</div>
                <div class="small text-muted">{{ step.date }}</div>
              </div>
            </div>
          </div>

          <div v-if="is_recipient_open(recipient.id)" class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
            <div class="d-inline-flex align-items-center gap-2 border rounded-2 bg-light px-3 py-2 small">
              <i class="bi bi-envelope"></i>
              <span>{{ recipient.activity }}</span>
            </div>

          </div>
        </article>
      </div>
    </div>
  </section>
</main>
